import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { IJobOrderDetail } from 'app/models';
import { JobOrderService } from 'app/services/job/job.order.service';
import { map } from 'rxjs/operators';
import { FlexLayoutModule } from '@angular/flex-layout';
import { saveAs } from 'file-saver';
export { FlexLayoutModule };
@Component({
  selector: 'app-job-order-detail',
  templateUrl: './job-order-detail.component.html',
  styleUrls: ['./job-order-detail.component.scss'],
})
export class JobOrderDetailComponent implements OnInit {
  @Input()
  jobOrderId?: number;

  @Output()
  backClick: EventEmitter<void> = new EventEmitter();

  @ViewChild('calendar', { static: false }) calendar:
    | MatCalendar<Date>
    | undefined;

  @ViewChild('histogram', {static: false}) histogram: any;

  jobOrderDetail?: IJobOrderDetail;
  deliveryDate: Date | null = null;
  chartData?: any = undefined;
  histogramData?: any = undefined;
  histogramOriginalData?: any = undefined;
  wastedToggle = false;

  constructor(private jobOrderService: JobOrderService) {}

  ngOnInit() {
    if (this.jobOrderId) {
      this.jobOrderService
        .getJobOrderOrderDetail(this.jobOrderId)
        .pipe(
          map((jobOrderDetail) => {
            this.jobOrderDetail = jobOrderDetail;
            this.deliveryDate = new Date(jobOrderDetail.deliveryDate);
            if (jobOrderDetail.data) {
              this.inflateChartData(jobOrderDetail.data);
            }
            if (jobOrderDetail.histogramData) {
              this.histogramOriginalData = jobOrderDetail.histogramData;
              this.inflateHistogramData(this.histogramOriginalData);
            }
          })
        )
        .subscribe();
    }
  }

  onBackClicked() {
    this.backClick.emit();
  }

  onCsvDownloadClicked() {
    if (this.jobOrderId) {
      this.jobOrderService.downloadJobOrderCSV(this.jobOrderId).subscribe((fileBlob: Blob) => {
        saveAs(fileBlob, `${this.jobOrderDetail?.code}-job.csv`);
    });
    }
  }

  onDataStatesCsvDownloadClicked() {
    if (this.jobOrderId) {
      this.jobOrderService.downloadJobOrderDataStatesCSV(this.jobOrderId).subscribe((fileBlob: Blob) => {
        saveAs(fileBlob, `${this.jobOrderDetail?.code}-job-data-state.csv`);
    });
    }
  }

  wastedToggleHandler() {
    this.wastedToggle=!this.wastedToggle;
    this.inflateHistogramData(this.histogramOriginalData);
    this.histogram.draw();
  }

  private inflateChartData(data: any) {
    this.chartData = {
      chartType: 'Timeline',
      options: {
        height: '400',
      },
      dataTable: [['Name', 'Start Time', 'End Time'], ...data],
    };
  }

  private inflateHistogramData(data: any) {
    let columnChartData = data.map((entry: any) => [entry.label, entry.value]);
    if(this.wastedToggle){
      columnChartData = columnChartData.filter((entry: any) => entry[0] !== 'WASTED');
    }
    this.histogramData = {
      chartType: 'ColumnChart',
      dataTable: [['', 'Min'], ...columnChartData],
    };
  }
}
